export default {"src":"/_next/static/media/location-time-line.ad5353c8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};